/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencySolana = createReactComponent("currency-solana", "IconCurrencySolana", [
  ["path", { d: "M4 18h12l4 -4h-12z", key: "svg-0" }],
  ["path", { d: "M8 14l-4 -4h12l4 4", key: "svg-1" }],
  ["path", { d: "M16 10l4 -4h-12l-4 4", key: "svg-2" }]
]);

export { IconCurrencySolana as default };
//# sourceMappingURL=IconCurrencySolana.js.map
